var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sys-update-info-wrap"},[_c('p',{staticClass:"system-update-text",on:{"click":_vm.seeUpdateInfo}},[_vm._v(" 通知：本月，平台财务系统将完成升级，本次升级后… > ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }